import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled", "size"]
const _hoisted_2 = { key: 1 }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingButton',
  props: {
    message: {
        type: String,
        default: 'Please wait...',
    },
    size:{
        type: String,
        default: 'default',
    },
    disabled:{
        type: Boolean,
        default: false,
    },
    saving:{
        type: Boolean,
        default: false,
    },
},
  setup(__props) {


const props = __props

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.disabled || __props.saving,
    size: __props.size,
    fill: "clear",
    class: _normalizeClass(["h-10 font-medium uppercase tracking-wide text-sm rounded-xl border-2 border-white text-white w-full mx-4 transition-all duration-200 hover:opacity-60", { 'opacity-50 cursor-not-allowed': __props.disabled || __props.saving }])
  }, [
    (__props.saving)
      ? (_openBlock(), _createBlock(_component_fa_icon, {
          key: 0,
          icon: ['far', 'spinner-third'],
          size: "2x",
          spin: ""
        }))
      : _createCommentVNode("", true),
    (!__props.saving)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.message), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})